module.exports = __webpack_public_path__ + "static/media/break.ef404ec8.svg";